import axios from "./axiosinstance";

const ProjectProgressApi = {
  list: () => axios.get("project-progress/list"), 
  details: (id) => axios.get(`project-progress/details/${id}`),
  updateStage: (payload) => axios.post("project-progress/update-stage", payload),
};

export default ProjectProgressApi;